<app-header #header title="Appeals"></app-header>

<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header" >
  <app-header-content ></app-header-content>

    <ion-grid style="min-height: 75%;" >
      <ion-row>
        <ion-col  style="text-align: center;">
          <h2 class="subheader-regular" >
            {{
              ('keys.data.users_menu.appeals' | translate : {Default:'Appeals'}) || 'Appeals'
              }}
          </h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-xs="12"
        size-md="10"
        offset-md="1"
        size-lg="9"
        offset-lg="1.5"
        size-xl="8"
        offset-xl="2">
          <ion-label  class="ion-text-wrap paragraph-input-fields-regular">
            {{ ('keys.data.violations.ticket_not_associated' | translate : {Default:'Ticket not associated to you or your vehicle?'} ) ||"Ticket not associated to you or your vehicle?"}} <span (click)="appealsSRV.allViolationspage()" style="color: #A02021;
            text-decoration-line: underline;cursor: pointer;">{{ ('keys.data.violations.lookup_all_tickets' | translate : {Default:'Lookup All Tickets'} ) ||"Lookup All Tickets"}}</span>
          </ion-label>
        </ion-col>
       
      </ion-row>
     
      <ion-row>
        <ion-col>
          <app-pagecontent [path]="'violations/appeals'"></app-pagecontent>

        </ion-col>
       </ion-row>
       <ion-row>
        <ion-col   class="single-col-wider">
          <ion-searchbar 
            placeholder="Search my tickets"
            debounce="100"
            (ionChange)="appealsSRV.tipo($event)"
            style="--border-radius: 0.5em"
            inputmode="text"
            [(ngModel)]="appealsSRV.searchItem"
            showCancelButton="focus"
            animated
          ></ion-searchbar>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="appealsSRV.loaded==true" >
        <ion-col  
        class="single-col-wider" *ngIf="appealsSRV.violations['violations']" >
          <div *ngIf="appealsSRV.violations['violations'].length>0">
            <ion-card  *ngFor="let violation of appealsSRV.violations['violations'] | filter:appealsSRV.searchItem; let i = index"
            style="border-radius: 0.5em;height: 100%;" class="card-shadow-7"
           >
           <ion-card-content style="padding-left: 0;padding-right: 0;">
           <ion-grid class="ion-no-padding" >
            <ion-row  >
              <ion-col style="padding: 0.4em;" >
                <ion-label class="paragraph-input-fields-bold">{{('keys.data.violations.ticket' | translate : {Default:'Ticket'}) || 'Ticket'}} #{{violation['Ticket']}}</ion-label>
                
              </ion-col>
              <ion-col  style="text-align: right;">
                <div *ngIf="!violation['payID'] || violation['appealType'] == appealsSRV['appealTypes'].cancelled">

                
                <ion-chip style="padding: 0.5em;"
                style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;"
                *ngIf="violation['timeLeft'] && violation.appealType !== appealsSRV.appealTypes.cancelled"
              >
                <ion-label
                  class="ion-text-wrap"
                  *ngIf="violation['timeLeft']['days']>0"
                  >{{violation['timeLeft']['days']}} {{ ('keys.data.violations.days_left' |
                  translate : {Default:'Days Left'}) || 'Days Left' }}</ion-label
                >
                <ion-label
                  class="ion-text-wrap"
                  *ngIf="violation['timeLeft']['days']<=0 && violation['timeLeft']['hours']>0 "
                  >{{violation['timeLeft']['hours']}} {{ ('keys.data.violations.hours_left' |
                  translate : {Default:'Hours Left'}) || 'Hours Left' }}</ion-label
                >
                <ion-label
                  class="ion-text-wrap"
                  *ngIf="violation['timeLeft']['days']<=0 && violation['timeLeft']['hours']<=0 "
                  >{{violation['timeLeft']['minutes']}} {{ ('keys.data.violations.minutes_left' |
                  translate : {Default:'Minutes Left'}) || 'Minutes Left' }}</ion-label
                ></ion-chip
              >
              <ion-chip style="font-weight: bold;" *ngIf="!violation['timeLeft'] && !violation['payID']" color="danger"
                ><ion-label>Past Due</ion-label>
              </ion-chip>
            </div>
              <ion-chip
        style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;"
        *ngIf="violation['payID'] && violation['appealType'] != appealsSRV['appealTypes'].cancelled"
        >{{ ('keys.data.violations.already_paid' | translate : {Default:'Already Paid'} )
        ||"Already Paid"}}</ion-chip
      >
              </ion-col>
            </ion-row>
           <ion-row *ngIf="violation['Plate']!=''">
            <ion-col>
              <ion-item lines="none">
                <ion-label class="paragraph-input-fields-bold">Plate</ion-label>
                <span class="ion-text-right ion-text-wrap paragraph-input-fields-regular" >{{violation.Plate}}</span>
              </ion-item>
              
            </ion-col>
           </ion-row>
           <ion-row>
            <ion-col>
              <ion-item lines="none">
                <ion-label
                  class="ion-text-wrap paragraph-input-fields-bold"
                  *ngIf="violation.Issued"
                  >{{ ('keys.data.violations.issued' | translate : {Default:'Issued'} )
                  ||"Issued"}}
                </ion-label>
                <span class="ion-text-right ion-text-wrap paragraph-input-fields-regular" >
                  {{violation.Issued |
                    date:dataService.settings['system']['datemask']}}
                </span>
              </ion-item>
            </ion-col>
           </ion-row>
           <ion-row>
            <ion-col>
              <ion-item lines="none" >
                <ion-label class="ion-text-wrap paragraph-input-fields-bold"
                 *ngIf="violation.Due"
                  >{{ ('keys.data.violations.due' | translate : {Default:'Due'} )
                  ||"Due"}}
                 
                </ion-label>
               
                
                <span class="ion-text-right ion-text-wrap paragraph-input-fields-regular" >
                    {{violation.Due |
                    date:dataService.settings['system']['datemask']}}
                  </span>
              </ion-item>
            </ion-col>
           </ion-row>
           <ion-row > 
            <ion-col>
              <ion-item 
                lines="none"
              >
                <ion-label class="ion-text-wrap paragraph-input-fields-bold" 
                  >Total</ion-label
                >
                <span class="ion-text-right ion-text-wrap " >
                  {{violation.CalculatedFine.finalTotal |
                  currency}}</span>
              </ion-item>
            </ion-col>
           </ion-row>
           <ion-row>
            <ion-col class="ion-no-padding">
              <ion-card  class="standard card-shadow-3" >
              <ion-accordion-group>
                <ion-accordion >
                  <div class="ion-no-padding" slot="content">
                    <ion-grid class="ion-no-padding">
                      <ion-row>
                        <ion-col>
                          <ion-item class="paragraph-input-fields-regular"
                          lines="none"
                          *ngFor="let detail of violation['details'];"
                        >
                          <ion-label class="ion-text-wrap" 
                            >{{detail.ViolationDescr}}</ion-label
                          >
                          <span [ngStyle]="{'text-decoration':appealsSRV.isCancelled(violation.appealType)}" style="color:var(--ion-color-danger)" class="ion-text-right ion-text-wrap paragraph-input-fields-regular" >
                            {{detail.offenceFine | currency}}</span>
                        </ion-item>
                                      
                        </ion-col>
                       </ion-row>
                       <ion-row>
                        <ion-col>
                          <ion-item lines="none" class="paragraph-input-fields-regular">
                            <ion-label class="ion-text-wrap" 
                              >Adjustment</ion-label
                            >
                            <span class="ion-text-right ion-text-wrap paragraph-input-fields-regular" >
                              {{violation.CalculatedFine.adjustment |
                              currency}}</span>
                          </ion-item>
                          
                        </ion-col>
                       </ion-row>
                       <ion-row > 
                        <ion-col>
                          <ion-item class="paragraph-input-fields-bold"
                            lines="none"
                          >
                            <ion-label class="ion-text-wrap" 
                              >Total</ion-label
                            >
                            <span class="ion-text-right ion-text-wrap paragraph-input-fields-bold" >
                              {{violation.CalculatedFine.finalTotal |
                              currency}}</span>
                          </ion-item>
                        </ion-col>
                       </ion-row>
                       <ion-row>
                        <ion-col style="text-align: center;">
                          <ion-button
                          (click)="appealsSRV.openViolationInfoModal(violation)"
                          
                          color="secondary"
                          >More info
                          </ion-button>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </div>
                  <ion-item slot="header"  class="paragraph-regular" >
                    <ion-label >Details</ion-label>
                  </ion-item>
                  
                </ion-accordion>
                </ion-accordion-group>
              </ion-card>
            </ion-col>
           </ion-row>
           
           </ion-grid>
          </ion-card-content>
             </ion-card>
         
        </div>
        </ion-col>
        </ion-row>
        <ion-row  *ngIf="appealsSRV.loaded==true">
          <ion-col class="single-col-wider"   *ngIf="appealsSRV.violations['violations']">
            <div *ngIf="appealsSRV.violations['violations'].length<1"  style="text-align: center">
                <ion-label style="font-weight: bold">
                  {{ ('keys.data.violations.user_has_no_violations' |
                  translate : {Default:'User has no violations.'}) || 'User has no violations.' }}
                </ion-label>
          </div>
           </ion-col>
        </ion-row>
        <ion-row *ngIf="appealsSRV.loaded==false">
        <ion-col class="single-col-wider">
          <ion-card *ngFor="let x of [0, 1, 2, 3]" >
            <ion-card-header style="text-align: center; font-weight: bold">
              <ion-title
                ><ion-skeleton-text
                  animated
                  style="width: 60%"
                ></ion-skeleton-text
              ></ion-title>
              <ion-card-subtitle
                ><ion-skeleton-text
                  animated
                  style="width: 60%"
                ></ion-skeleton-text
              ></ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <ion-row>
                <ion-col>
                  <ion-item>
                    <ion-skeleton-text
                      animated
                      style="width: 40%"
                    ></ion-skeleton-text>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item>
                    <ion-skeleton-text
                      animated
                      style="width: 40%"
                    ></ion-skeleton-text>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item>
                    <ion-skeleton-text
                      animated
                      style="width: 40%"
                    ></ion-skeleton-text>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  <ion-footer class="ion-no-border">
    <app-footer></app-footer>
  </ion-footer>
</ion-content>
